const VideoSVG = ({ size = 24, color = "currentColor", className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Camera body — filled */}
      <rect x="2" y="7" width="13" height="10" rx="2" fill={color} />
      {/* Camera lens triangle — filled */}
      <path d="M15 10.5l5-3v9l-5-3V10.5z" fill={color} />
    </svg>
  );
};

export default VideoSVG;
